import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ICtoContract } from '../../../core/models/cto.model';
import { IKkm } from '../../../core/modules/retail-places/retail-paces.types';

@Component({
  selector: 'tax-contract',
  templateUrl: './contract.component.html',
  styleUrls: ['./contract.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class ContractComponent {
  // @ts-ignore
  @Input() contract: ICtoContract;

  calculateRetailPlaceCount(kkms: Array<IKkm>): number {
    const retailPlaces: Set<number> = new Set<number>();
    kkms.forEach(
      (kkm: IKkm) => retailPlaces.add(kkm.retailPlaceId),
    );
    return retailPlaces.size;
  }

  calculateKkmCount(kkms: Array<IKkm>): number {
    return kkms.length || 0;
  }
}
